/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Online_Price_Product_Not_FoundInputs */

const vi_error_online_price_product_not_found = /** @type {(inputs: Error_Online_Price_Product_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm không còn tồn tại. Tải lại bảng giá.`)
};

/**

* @param {Error_Online_Price_Product_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_online_price_product_not_found = /** @type {((inputs?: Error_Online_Price_Product_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Online_Price_Product_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_online_price_product_not_found(inputs)
});